import React from "react";
import Skeleton from "react-loading-skeleton";

const BrokerSkeleton = ({ rows = 6, variant = "detail" }) => {
  if (variant === "cards") {
    return (
      <div className="broker-skeleton-cards" aria-label="Loading content">
        {Array.from({ length: rows }, (_, index) => (
          <div className="broker-skeleton-card" key={index}>
            <Skeleton circle width={42} height={42} />
            <div>
              <Skeleton width="52%" height={12} />
              <Skeleton width="82%" height={24} />
            </div>
          </div>
        ))}
      </div>
    );
  }

  return (
    <div className={`broker-skeleton broker-skeleton--${variant}`} aria-label="Loading content">
      <Skeleton width="34%" height={18} />
      {Array.from({ length: rows }, (_, index) => (
        <div className="broker-skeleton__row" key={index}>
          <Skeleton width="28%" height={12} />
          <Skeleton width="72%" height={16} />
        </div>
      ))}
    </div>
  );
};

export default BrokerSkeleton;
